var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM15.8209 9.29289C16.2034 9.75292 15.9325 10.5395 15.3916 10.5395H8.6084C8.06746 10.5395 7.79655 9.75292 8.17906 9.29289L11.5707 5.21388C11.8078 4.92871 12.1922 4.9287 12.4293 5.21388L15.8209 9.29289ZM15.8209 14.7071L12.4293 18.7861C12.1922 19.0713 11.8078 19.0713 11.5707 18.7861L8.17906 14.7071C7.79655 14.2471 8.06746 13.4605 8.6084 13.4605H15.3916C15.9325 13.4605 16.2034 14.2471 15.8209 14.7071Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/select-arrow.0f79e0bbb0cd54ed8ea4055705e4410f.svg";
export { ForwardRef as ReactComponent };